import { router, usePathname } from 'expo-router'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Card } from '@/src/elements/card'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import type { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants/TrackingSource.enum'
import { useRoutes } from '@/src/general/utils/routes'

export type TIsNotWatchmanSectionProps = {
  trackingSource: TRACKING_SOURCE
  theme: string | undefined
}

export const IsNotWatchmanSection = ({ trackingSource, theme }: TIsNotWatchmanSectionProps): ReactNode => {
  const { routes } = useRoutes()
  const redirect = usePathname()

  return (
    <Card
      testID={TEST_ID.WATCHMAN.SECTION_BUTTON}
      className="flex w-full flex-row items-center justify-between gap-4 rounded-xl bg-secondary-bg-light p-4 shadow-sm"
      isPressable
      onPress={() => router.navigate(routes.askWatchman({ source: trackingSource, theme, redirect }))}
    >
      {/* Left Icon (Lantern) */}
      <Icon name={ICON.LANTERN} size="xl" className="text-secondary-text-contrast-low" />

      {/* central content  */}
      <View className="flex-col gap-2 flex flex-1">
        <Typography colors="secondary" bold>
          <FormattedMessage id="intention.prayer.watchman.become" />
        </Typography>
        <Typography colors="secondary">
          <FormattedMessage id="watchman.three.intentions" />
        </Typography>
      </View>

      {/* Right Icon */}
      <Icon name={ICON.CHEVRON_RIGHT} className="text-secondary-text-contrast-low" />
    </Card>
  )
}
